import "../css/bookclosure.css";
import buttoncss from "../css/button.module.css";
import commoncss from "../css/common.module.css";
import SideMenu from "../elements/SideMenu";
import { DisplayCard, DisplayCardInactive } from "../elements/DisplayCards";
import PaginationFooter from "./../elements/PaginationFooter";
import StatusIndicator from "../elements/StatusIndicator";
import { Button, FilterButton } from "../elements/Button";
import BookClosureTable from "../elements/BookClosureTable";
import ToggleButton from "../elements/ToggleButton";
import { ReactComponent as LeftArrowIcon } from "../assets/icons/left_arrow.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";

const BookClosureComments = () => {
  const menuItems = [
    {label:"Overview",link:"/myfinv2/"},
    {label:"Book Closures",link:"/myfinv2/book-closure"},
    {label:"Standalone",link:"/myfinv2/"},
    {label:"Consolidation",link:"/myfinv2/"},
    {label:"Team Members",link:"/myfinv2/"},
    {label:"Workspace Settings",link:"/myfinv2/"}
  ];

  const redirectToBookClosureHome = () => {
    window.location.href = "/myfinv2/book-closure";
  };


  const statusMap = {
    C: "Resolved",
    I: "Unresolved",
    S: "Closed",
    D: "Over Due",
  };

  const tableHeaders = {
    comment: "COMMENT",
    task: "TASK",
    assignedTo: "ASSIGNED TO",
    approver: "APPORVER",
    dueDate: "DUE DATE",
    status: "STATUS",
    lastActivity: "LAST ACTIVITY",
  };

  const rowData = [
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["C"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["S"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["C"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["D"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1","User 2"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["I"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1","User 2","User 3"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["I"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
    {
      comment: "Comment",
      task: "Task Consol FS",
      assignedTo: ["User 1","User 2"],
      approver: "Username",
      dueDate: "12-04-2024",
      status: <StatusIndicator status={statusMap["I"]} />,
      lastActivity: "Apr 07, 09:43 AM",
    },
  ];

  const columnClasses = {
    module: "bkclTableBoldTd",
    task: "bkclTableTemplateNameTd",
  };

  const headerClasses = {
    taskTemplateName: "bkclTableTemplateNameTh",
  };

  return (
    <div className="book-closure-page">
      <SideMenu
        title="Base - Base Corporation"
        menuItems={menuItems}
        activeItem="Book Closures"
      />
      <div className="book-closure-content">
        <div className="book-closure-header">
          <div className="header-content">
            <LeftArrowIcon
              width={24}
              height={24}
              className="clickable"
              onClick={redirectToBookClosureHome}
            />
            <span className="header-title-bookclosure">Comments</span>
            <SearchIcon />
            &nbsp;
            <FilterIcon />
          </div>
        </div>
        <div className="book-closure-data">
          <DisplayCard
            class_="displayCommentCardActive"
            label="ALL COMMENTS"
            value="85"
          />
          <DisplayCardInactive
            class_="displayCommentCardInactive"
            label="ASSIGNED TO ME"
            value="3"
          />
          <DisplayCardInactive
            class_="displayCommentCardInactive"
            label="OVERDUE"
            value="4"
          />
          <DisplayCardInactive
            class_="displayCommentCardInactive"
            label="UNRESOLVED"
            value="13"
          />
          <DisplayCardInactive
            class_="displayCommentCardInactive"
            label="RESOLVED"
            value="12"
          />
          <DisplayCardInactive
            class_="displayCommentCardInactive"
            label="CLOSED COMMENTS"
            value="68"
          />
        </div>
        <br />
        <div className={`${commoncss.pdlr30}`}>
          <FilterButton active={true} label="All Comments" />
          &ensp;
          <FilterButton active={false} label="Assigned to me" />
          &ensp;
          <FilterButton active={false} label="Created by me" />
        </div>
        <div className={`${commoncss.pdlr30} ${commoncss.m_tb_20}`}>
          <div className={`table-container-book-closure`}>
            <BookClosureTable
              tableHeaders={tableHeaders}
              rowData={rowData}
              columnClasses={columnClasses}
              headerClasses={headerClasses}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookClosureComments;
